import React from 'react';
import { default as Component } from '@plone/volto/components/theme/Component/Component';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faGlobe, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

const extractChild = (label) => {
  const splitted = label.split(' » ');
  if (splitted.length > 1) {
    return splitted[1];
  }
  return null;
};
const resolveVocabItems = (ids, items, onlyChilds = false) => {
  return ids && ids.length > 0
    ? ids.reduce((acc, id) => {
        acc.push({
          token: id,
          title: onlyChilds
            ? extractChild(items.find((item) => item.value === id)?.label)
            : items.find((item) => item.value === id)?.label,
        });
        return acc;
      }, [])
    : [];
};
export const ServiceGridListingItemTemplate = (props) => {
  const { item } = props;

  const taxonomy_state = useSelector(
    (state) => state?.vocabularies?.['collective.taxonomy.companytype'],
  );
  const country_state = useSelector(
    (state) => state?.vocabularies?.['collective.taxonomy.CountryVocabulary'],
  );

  return (
    <div className="card-container item-service">
      <div className="top-part">
        <div className="item-header">
          <h3>{item?.title}</h3>
        </div>
        <div className="image-container">
          {item.image_field !== '' && (
            <Component
              componentName="PreviewImage"
              item={item}
              alt={item?.title}
              className="item-image"
              width={163}
            />
          )}
        </div>
        <div className="service-info">
          {item?.service_object && <div>{item?.service_object}</div>}
          {item?.service_name && <div>{item?.service_name}</div>}
          {taxonomy_state?.items?.length > 0 &&
            resolveVocabItems(
              item?.taxonomy_companytype,
              taxonomy_state?.items,
              false,
            ).length > 0 && (
              <div>
                {resolveVocabItems(
                  item?.taxonomy_companytype,
                  taxonomy_state?.items,
                  false,
                )
                  ?.map((taxonomy, index) => (
                    <span key={taxonomy?.token}>{taxonomy?.title}</span>
                  ))
                  .reduce((prev, curr) => [prev, ', ', curr])}
              </div>
            )}
        </div>
      </div>
      <div className="service-contact-info">
        {item?.service_mail && (
          <div className="icon-info">
            <FontAwesomeIcon icon={faEnvelope} />
            <a href={`mailto:${item?.service_mail}`}>{item?.service_mail}</a>
          </div>
        )}
        {item?.service_phone_number && (
          <div className="icon-info">
            <FontAwesomeIcon icon={faPhone} /> {item?.service_phone_number}
          </div>
        )}
        {item?.service_web && (
          <div className="icon-info">
            <FontAwesomeIcon icon={faGlobe} />{' '}
            <a href={item?.service_web} target="_blank" rel="noreferrer">
              <FormattedMessage
                id="Visit website"
                defaultMessage="Visit website"
              />
            </a>
          </div>
        )}
        {item?.service_address && <div>{item?.service_address}</div>}
        {country_state?.items?.length > 0 &&
          resolveVocabItems(
            [item?.service_country],
            country_state?.items,
          )[0] && (
            <div>
              {
                resolveVocabItems(
                  [item?.service_country],
                  country_state?.items,
                )[0]
              }
            </div>
          )}
      </div>
      <div className="person-contact-info">
        {item?.contact_name && (
          <div className="icon-info">
            <strong>{item?.contact_name}</strong>
          </div>
        )}
        {item?.contact_mail && (
          <div className="icon-info">
            <FontAwesomeIcon icon={faEnvelope} />
            <a href={`mailto:${item?.contact_mail}`} rel="noreferrer">
              {item?.contact_mail}
            </a>
          </div>
        )}
        {item?.contact_phone_number && (
          <div className="icon-info">
            <FontAwesomeIcon icon={faPhone} />
            {item?.contact_phone_number}
          </div>
        )}
      </div>
    </div>
  );
};
